import React from "react";
import "../SboePage.css";

export default function ExcluirModal({ open, registro, onClose, onConfirm }) {
  if (!open) return null;

  return (
    <div className="sboe-modal-overlay" onClick={onClose}>
      <div className="sboe-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="sboe-modal-head">
          <h2>Excluir registro</h2>
        </div>

        <div className="sboe-modal-body">
          <p className="sboe-modal-text">
            Confirma a exclusão do registro <b>#{registro?.id}</b>?
          </p>
          <p className="sboe-modal-pair">
            SUB: {registro?.sub || "-"} | SB: {registro?.sb || "-"}
          </p>
        </div>

        <div className="sboe-modal-foot">
          <button className="sboe-btn" onClick={onClose}>
            Cancelar
          </button>
          <button className="sboe-btn sboe-btn-danger" onClick={onConfirm}>
            Excluir
          </button>
        </div>
      </div>
    </div>
  );
}
